export default "__VITE_ASSET__q6DUIYsN__"